<template>
  <v-dialog v-model="cPaymentVueDialog" persistent max-width="500" scrollable>
    <v-form ref="form1" @submit.prevent="onSave">
      <v-card outlined>
        <v-card-title class="primary white--text">{{ pay == "refund" ? $t('payment.refund') : $t('payment.pay') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text min-height="600">
          <div class="my-3 text-lg text-center" v-if="objectArray && objectArray.length && pay == 'refund'">
            <div>
              {{ $t('payment.refund_all') }}
              <b>{{ objectArray.length }}</b> {{ $t('list') }}
            </div>
            <span class="mx-2 text-xl font-bold">{{ $t('payment.amount_of_money') }} {{ sumField(objectArray, 'refundCost') | currencySuffixTextThEn }}</span>
          </div>
          <div class="my-3 text-lg text-center" v-if="!(objectArray && objectArray.length && pay == 'refund')">
            <span>{{ $t('payment.amount') }}</span>
            <span class="mx-2 text-xl font-bold"> {{ getCheckout.totalCostAbs | currencySuffixTextThEn }}</span>
          </div>
          <!-- Content Space -->
          <template v-if="pay == 'refund'">
            <div class="py-3">
              <div class="pt-2 text-center">{{ $t('payment.refund_channel') }}</div>
              <v-radio-group class="radio-group-refund" v-model="form.paymentMethod" row hide-details
                :rules="rules.paymentMethod">
                <v-radio :label="$t('payment.cash')" value="1"></v-radio>
                <v-radio :label="$t('payment.transfer')" value="2"></v-radio>
                <v-radio :label="$t('payment.cash_check')" value="6"></v-radio>
              </v-radio-group>
            </div>
            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value.sync="form.date"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field solo flat :value="$helper.datelabel(form.date)" :label="$t('payment.payment_date')"
                  prepend-inner-icon="mdi-calendar" readonly hide-details v-bind="attrs" outlined
                  v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="form.date" no-title scrollable locale="th"
                :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth" persistent-hint>
                <v-spacer></v-spacer>
                <v-btn text color="error" @click="menu1 = false">{{ $t('cancel') }}</v-btn>
                <v-btn text color="success" @click="$refs.menu1.save(form.date)">{{ $t('confirm') }}</v-btn>
              </v-date-picker>
            </v-menu>
            <div class="mt-4">{{ $t('payment.attach_refund_proof') }}</div>
            <v-row v-if="form.paymentProofFiles && form.paymentProofFiles.length">
              <v-col cols="12" sm="6" v-for="(file, index) in form.paymentProofFiles" :key="index">
                <v-card>
                  <v-img :src="file.url">
                    <v-app-bar flat color="rgba(0, 0, 0, 0)">
                      <v-spacer></v-spacer>
                      <v-btn style="margin: -25px -15px 0 0" class="error white--text" elevation="2" icon rounded small
                        @click="removeFile(index)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-app-bar>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
            <div class="mt-3">
              <v-text-field style="cursor: pointer !important" :value="$t('add_picture')" class="input-center"
                :placeholder="$t('date')" outlined hide-details readonly @click="openFileDialog()"></v-text-field>
              <input ref="uploader" class="input-center d-none" :placeholder="$t('attach_proof')" outlined hide-details
                clear-icon prepend-icon type="file" accept="image/*" @input="uploadSlip" />
            </div>
          </template>
          <template v-if="pay == 'extra'">
            <div class="p-2 mb-2 text-center border rounded bg-web-orange-50 border-web-orange-400 text-web-orange-600">
              {{ $t('payment.full_payment') }}</div>
            <div class="py-3">
              <div class="pt-2">{{ $t('payment.pay_method') }}</div>
              <v-radio-group v-model="form.paymentMethod" row hide-details validate-on-blur :rules="rules.paymentMethod">
                <v-radio :label="$t('payment.cash')" value="1"></v-radio>
                <v-radio :label="$t('payment.bank_transfer')" value="2"></v-radio>
                <v-radio :label="$t('payment.debit_credit')" value="3"></v-radio>
              </v-radio-group>
            </div>
            <!-- vuetify date picker -->
            <div class="mt-4">{{ $t('payment.payment_date') }}</div>
            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value.sync="form.date"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field outlined flat :value="$helper.datelabel(form.date)" prepend-inner-icon="mdi-calendar"
                  readonly hide-details v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="form.date" no-title scrollable locale="th"
                :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth" persistent-hint>
                <v-spacer></v-spacer>
                <v-btn text color="error" @click="menu1 = false">{{ $t('cancel') }}</v-btn>
                <v-btn text color="success" @click="$refs.menu1.save(form.date)">{{ $t('confirm') }}</v-btn>
              </v-date-picker>
            </v-menu>
            <div class="py-3" v-if="form.paymentMethod == '2'">
              <div class="pt-2">{{ $t('payment.transfer_to_bank') }}</div>
              <v-select v-model="form.paymentBankAccount" :items="bankAccounts || []" item-text="accountName"
                item-value="objectId" class="input-center" :placeholder="$t('payment.access_to_bank_account')" outlined
                hide-details :rules="rules.paymentBankAccount" :no-data-text="$t('noinfo')">
                <template v-slot:selection="{ item }" @>
                  <v-list-item-avatar class="mx-0 my-0">
                    <v-img :src="require(`../assets/images/bank/${item.bankCode}.jpg`)
                      " max-width="35" max-height="35" />
                  </v-list-item-avatar>
                  <span class="ms-3">
                    {{ item.accountName }} [ {{ item.accountNumber }} ]
                    <br />
                    <small>
                      <b>{{ $t('payment.branch') }} :</b>
                      {{ item.accountBranch }}
                    </small>
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <template>
                    <v-list-item-avatar>
                      <v-img :src="require(`../assets/images/bank/${item.bankCode}.jpg`)
                        " />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.accountName }} [ {{ item.accountNumber }} ]
                        <br />
                        <small>
                          <b>{{ $t('payment.branch') }} :</b>
                          {{ item.accountBranch }}
                        </small>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-select>
              <div class="mt-4">{{ $t('payment.attach_slip') }}</div>
              <v-row v-if="form.paymentProofFiles && form.paymentProofFiles.length">
                <v-col cols="12" sm="6" v-for="(file, index) in form.paymentProofFiles" :key="index">
                  <v-card>
                    <v-img :src="file.url">
                      <v-app-bar flat color="rgba(0, 0, 0, 0)">
                        <v-spacer></v-spacer>
                        <v-btn style="margin: -25px -15px 0 0" class="error white--text" elevation="2" icon rounded small
                          @click="removeFile(index)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-app-bar>
                    </v-img>
                  </v-card>
                </v-col>
              </v-row>
              <div class="mt-3">
                <v-text-field style="cursor: pointer !important" :value="$t('add_picture')" class="input-center"
                  :placeholder="$t('date')" outlined hide-details readonly @click="openFileDialog()"></v-text-field>
                <input ref="uploader" class="input-center d-none" :placeholder="$t('attach_proof')" outlined hide-details
                  clear-icon prepend-icon type="file" accept="image/*" @input="uploadSlip" />
              </div>
            </div>
          </template>
          <div class="py-2">
            <div class="pt-2">{{ $t('note') }}</div>
            <v-textarea v-model="form.paymentNote" outlined :label="$t('note')" no-resize solo flat
              hide-details></v-textarea>
          </div>
          <div class="py-3 text-center" v-if="isLoading && queryArray">{{ $t('queue_index_from_total', { count: queryCount, total: objectArray.length }) }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="onCancel" :disabled="isLoading">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" elevation="0" type="submit" :disabled="isDisable || isLoading" :loading="isLoading">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card></v-form>
    <v-snackbar v-model="isError" :timeout="1500" centered color="error">{{ $t('validate.error_save_data') }}</v-snackbar>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { FileUpload } from "../classes";
export default {
  name: "CPaymentVue",
  props: {
    value: Boolean,
    objectId: String,
    objectArray: Array,
    isDisable: Boolean,
    isUpdate: Boolean,
    isCreate: Boolean,
    pay: String,
    queryArray: Boolean,
    paymentMethod: Number,
    paymentProofFiles: Array,
    paymentBankAccount: Object
  },
  computed: {
    ...mapGetters({
      getCheckout: "contractCheckout/contractCheckout",
      projectId: "markets/getProjectId",
      bankAccounts: "bankAccount/getBankAccounts"
    }),
    cPaymentVueDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    value(data) {
      if (data) {
        this.initData();
        this.initBankAccounts();
        this.resetForm();
      }
    }
  },
  data() {
    return {
      form: {
        paymentMethod: "1",
        date: this.$moment().format("YYYY-MM-DD"),
        paymentProofFiles: []
      },
      rules: {
        paymentMethod: [
          v => !!v || this.$t('validate.please_select_payment_method')
        ],
        date: [
          v => !!v || this.$t('validate.please_select_payment_date'),
          v => this.$helper.isDate(v) || this.$t('validate.please_select_payment_date_correct')
        ],
        paymentBankAccount: [
          v => !!v || this.$t('validate.please_select_payment_bank_account')
        ],
        paymentProofFiles: [
          v => !!v || this.$t('validate.please_upload_payment_proof')
        ]
      },
      text: {},
      menu1: false,
      bankList: [],
      isError: false,
      isLoading: false,
      queryCount: 0
    };
  },
  created() {
    this.text = {
      title: "CPaymentVue",
      isCreate: this.$t('action_type.create'),
      isUpdate: this.$t('action_type.edit')
    };
  },
  methods: {
    ...mapActions({
      getBankAccounts: "bankAccount/getBankAccounts",
      payContractCheckout: "contractCheckout/payContractCheckout",

    }),
    ...mapMutations({
      addBankAccounts: "bankAccount/addBankAccounts"
    }),
    async uploadSlip($event) {
      try {
        if ($event.target.files && $event.target.files[0]) {
          const fileUpload = await FileUpload.upload($event.target.files[0]);
          this.form.paymentProofFiles.push(fileUpload);
        }
      } catch (error) {
        console.log(error);
      }
    },
    initData() {
      this.$emit("onInit");
    },
    async initBankAccounts() {
      try {
        await this.getBankAccounts(this.projectId);
        this.initPaymentBankAccount();
      } catch (error) {
        this.isError = true;
      }
    },
    async saveData() {
      try {
        let data;
        if (this.pay == "extra") {
          if (
            this.form.paymentMethod == "1" ||
            this.form.paymentMethod == "3"
          ) {
            data = {
              paymentMethod: parseInt(this.form.paymentMethod),
              date: new Date(this.$moment(this.form.date).toDate()),
              paymentNote: this.form.paymentNote
            };
          } else if (this.form.paymentMethod == "2") {
            let bankAccount;
            if (this.form.paymentBankAccount) {
              let obj = this.bankAccounts.find(
                d => d.objectId == this.form.paymentBankAccount
              );
              bankAccount = {
                bankCode: obj.bankCode,
                accountName: obj.accountName,
                accountNumber: obj.accountNumber,
                accountBranch: obj.accountBranch
              };
            }
            data = {
              paymentMethod: parseInt(this.form.paymentMethod),
              date: new Date(this.$moment(this.form.date).toDate()),
              paymentNote: this.form.paymentNote,
              paymentBankAccount: bankAccount,
              paymentProofFiles: this.form.paymentProofFiles
            };
          }
        } else if (this.pay == "refund") {
          data = {
            date: new Date(this.$moment(this.form.date).toDate()),
            paymentMethod: parseInt(this.form.paymentMethod),
            paymentNote: this.form.paymentNote,
            paymentProofFiles: this.form.paymentProofFiles,
          };
        }
        this.isLoading = true;
        if (this.$refs.form1.validate()) {
          if (this.queryArray) {
            const fnc = await this.objectArray.map(async item => {
              await this.payContractCheckout({ ...data, id: item.objectId });
              this.queryCount++;
            });
            await Promise.all(fnc);
            this.queryCount = 0;
          } else {
            await this.payContractCheckout({ ...data, id: this.getCheckout.objectId });
          }
        }
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        this.isError = true;
        console.log(e);
      }
    },
    async onSave() {
      try {
        await this.saveData();
        this.$emit("onSave");
        this.cPaymentVueDialog = false;
      } catch (e) {
        console.log(e);
      }
    },
    resetForm() {
      if (this.$refs.form1) this.$refs.form1.resetValidation();
      this.form = {
        paymentMethod: "1",
        date: this.$moment().format("YYYY-MM-DD"),
        paymentProofFiles: []
      };
      if (this.paymentMethod) this.form.paymentMethod = `${this.paymentMethod}`;
      if (this.paymentProofFiles)
        this.form.paymentProofFiles = this.paymentProofFiles;
    },
    onCancel() {
      try {
        this.$emit("onCancel", this.form);
        this.cPaymentVueDialog = false;
      } catch (e) {
        console.log(e);
      }
    },
    initPaymentBankAccount() {
      if (this.paymentBankAccount && this.bankAccounts) {
        let bankAccount;
        bankAccount = this.bankAccounts.find(
          d =>
            d.accountNumber == this.paymentBankAccount.accountNumber &&
            d.accountName == this.paymentBankAccount.accountName &&
            d.bankCode == this.paymentBankAccount.bankCode
        );
        if (bankAccount) {
          this.form.paymentBankAccount = bankAccount.objectId;
        } else if (this.paymentBankAccount) {
          let date = new Date();
          this.addBankAccounts({ objectId: date.getTime(), ...this.paymentBankAccount });
          this.form.paymentBankAccount = date.getTime();
        }
        this.$forceUpdate();
      }
    },
    openFileDialog() {
      this.$refs.uploader.click();
    },
    removeFile(index) {
      this.form.paymentProofFiles.splice(index, 1);
    },
    sumField(data, key, key2) {
      if (data && data.length && key && key2)
        return data.reduce((a, b) => a + (b[key] * b[key2] || 0), 0);
      else if (data && data.length && key && !key2)
        return data.reduce((a, b) => a + (b[key] || 0), 0);
      else return 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-group-refund {
  margin-top: 0;
  margin-bottom: 15px;
}

.radio-group-refund::v-deep .v-input--radio-group__input {
  justify-content: center;
}
</style>
